// extracted by mini-css-extract-plugin
module.exports = {"AccordionPanelUi":"styles_AccordionPanelUi___fBEe","head":"styles_head__1PnNE","arrowIcon":"styles_arrowIcon__2oZlp"};